import React from 'react';

function AboutHero() {
  return (
    <section 
      className="team-hero" 
      style={{ backgroundImage: "url('/assets/images/nextgen-banner-1-fb9ebf40dfa68b02e4cac74dd2c94870-1.webp')" }}
    >
      {/* Dark overlay matching the design */}
      <div className="team-hero-overlay"></div>

      {/* Hero Content */}
      <div className="container team-hero-container">
        <div className="team-hero-content">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', marginBottom: '1.2rem' }}>
            <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '1rem', fontFamily: "'Poppins', sans-serif" }}>
              About Us
            </span>
            <span style={{ display: 'inline-block', width: '60px', height: '2px', backgroundColor: '#ffffff' }}></span>
          </div>

          <h1 className="team-hero-title">
            Maximize Your Business Potential: Expert Solutions for the Digital Age
          </h1>

          <p className="team-hero-description">
            Helping brands and businesses with the best BPO, IT services, digital marketing, and quality web solutions since 2016.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutHero;
